import React, { useEffect, useRef } from "react";

import commaNumber from "comma-number";

import ReactTable from "react-table-v6";
import "react-table-v6/react-table.css";
import "./style.scss";

function Slide3(props) {
  const mounted = useRef();

  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true;
    } else {
      if (props.slideData?.length > 0) {
        props.getData({
          type: "table",
          title: "Open and closed",
          filter: {
            brands: props.filter.data.brands.map((brand) => brand.name),
            chains: props.filter.data.chains.map((chain) => chain.name),
            revCent: props.filter.data.revCent.map((revCent) => revCent.name),
            payType: props.filter.data.payType.map((payType) => payType.name),
            date: {
              start: props.filter.data.date.start,
              end: props.filter.data.date.end,
            },
          },
          body: [
            {
              head: [["Buisness name", "Checks", "Open", "Closed", "Total"]],
              body: props.slideData?.map((value) => [
                value.restaurant_name,
                commaNumber(value.checkCount || 0),
                `${value.totalOpenSales} ${value.currency}`,
                `${value.totalClosedSales} ${value.currency}`,
                `${value.totalClosedSales + value.totalOpenSales} ${
                  value.currency
                }`,
              ]),
            },
          ],
        });
      }
    }
  }, [props.export]);

  const columns = [
    {
      Header: "Business Name",
      accessor: "restaurant_name",
      filterMethod: (filter, row) => {
        if (filter.value === "all") {
          return true;
        }

        if (row[filter.id] === filter.value) {
          return row[filter.id];
        }
      },
      Filter: ({ filter, onChange }) => {
        return (
          <select
            onChange={(event) => onChange(event.target.value)}
            style={{ width: "100%" }}
            value={filter ? filter.value : "all"}
          >
            <option value="all">All</option>
            {[
              ...new Set(
                props?.slideData.map((table) => table.restaurant_name)
              ),
            ].map((name) => (
              <option value={name}>{name}</option>
            ))}
          </select>
        );
      },
    },

    {
      Header: "Checks",
      accessor: "checkCount",
      Cell: (row) => {
        return commaNumber(row.value || 0);
      },
    },

    {
      Header: "Open",
      accessor: "totalOpenSales",
      Cell: (row) => {
        return `${row?.original?.currency?.toUpperCase()} ${commaNumber(
          row.value.toFixed(2)
        )}`;
      },
    },
    {
      Header: "Closed",
      accessor: "totalClosedSales",
      Cell: (row) => {
        return `${row?.original?.currency?.toUpperCase()} ${commaNumber(
          row.value.toFixed(2)
        )}`;
      },
    },
    {
      Header: "Total",
      Cell: (row) => {
        return `${row?.original?.currency?.toUpperCase()} ${commaNumber(
          (row.original.totalClosedSales + row.original.totalOpenSales).toFixed(
            2
          )
        )}`;
      },
    },
  ];

  return (
    <div>
      <ReactTable
        className={["-striped", "-highlight"].join(" ")}
        data={props.slideData}
        columns={columns}
        sortable
        filterable
        getTdProps={() => ({
          style: {
            textAlign: "center",
          },
        })}
      />
    </div>
  );
}

export default Slide3;
